import { memo } from 'react';
import { cn } from '../../../utils/string/cn.utils';
import { Spin } from 'antd';

const ButtonPrimarySmall = ({
  id,
  title,
  preIcon,
  posIcon,
  disabled,
  style,
  onClick,
  type = 'button',
  loading = false,
  ...props
}) => {
  return (
    <button
      type={type}
      id={id}
      className={cn(
        'inline-flex justify-center items-center bg-primary-primary hover:bg-primary-primaryVarient1 disabled:bg-primary-primaryVarient2 disabled:text-white-medium',
        'h-[24px] py-[4px] px-[8px] gap-[4px] text-body-small font-semibold rounded-[6px]',
        props.className
      )}
      disabled={disabled}
      style={{
        ...style,
        ...{
          paddingRight: `${preIcon ? '8px' : undefined}`,
          paddingLeft: `${posIcon ? '8px' : undefined}`,
        },
      }}
      onClick={onClick}
    >
      {posIcon && (
        <div className="flex flex-row justify-center items-center w-[18px] h-[18px] text-white-high disabled:text-white-medium">
          {posIcon}
        </div>
      )}
      <span className="truncate text-white-high disabled:text-white-medium">
        {title}
      </span>
      <Spin spinning={loading} size={16} />
      {preIcon && (
        <div className="flex flex-row justify-center items-center w-[18px] h-[18px] text-white-high disabled:text-white-medium">
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default memo(ButtonPrimarySmall);
